import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const shipToAddressSchema = z.object({
  name: z.string(),
  street1: z.string(),
  street2: z.string().optional(),
  city: z.string(),
  state: z.string().optional(),
  zip: z.string(),
  country: z.string(),
});

const returnsCenterConfigSchema_ = z.object({
  consolidationScheduleDays: z.number().nullable(),
  shipToAddress: shipToAddressSchema.nullable(),
  refulfillment: z.boolean().nullable(),
  processingFee: z.number().nullable(),
  provider: z.string().nullable(),
  externalHub: z
    .object({ provider: z.string(), locationId: z.string().nullable() })
    .nullable(),
});
export type ReturnsCenterConfig = z.infer<typeof returnsCenterConfigSchema_>;

const returnsCenterSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  country: z.string().nullable(),
  config: returnsCenterConfigSchema_,
});
export const returnsCenterSchema: z.ZodType<ReturnsCenter> =
  returnsCenterSchema_;
export interface ReturnsCenter extends z.infer<typeof returnsCenterSchema_> {}

export const getReturnsCenters = unaryRpc({
  name: "getReturnsCenters" as const,
  input: z.object({}),
  output: z.object({ returnsCenters: z.array(returnsCenterSchema) }),
});
